'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('corporateRoleModule')

.factory('corporateRoleService', ['$http', function ($http) {
    var baseUrl = environment.apiUrl + '/Pilot/api/CorporateRole';

    var service = {};

    // CorporateRole
    service.getCorporateRole = function (corporateRoleId) {
        return $http
            .get(baseUrl + '/' + corporateRoleId)
            .then(function (response) { return response.data; });
    };

    service.createOrUpdateCorporateRole = function (corporateRole) {
        var reqUrl = baseUrl;
        if (!_.isUndefined(corporateRole.CorporateRoleID)) reqUrl += '/' + corporateRole.CorporateRoleID;

        return $http
            .post(reqUrl, { CorporateRole: corporateRole })
            .then(function (response) { return response.data; });
    };

    return service;
}]);
